import { Box, Grid, Link, Paper, Typography } from '@mui/material';

export default function TenNinetyNineFilingStates() {
  return (
    <Grid
      container
      spacing={2}
      className="MuiGrid-root-width"
      justifyContent="center"
      sx={{
        '& .MuiPaper-root:hover': {
          boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
          transition: '0.3s',
          borderColor: '#ccc',
        },
      }}
    >
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/alabama-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: 'grid',
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              // width: { md: 'auto', sm: '250px !important', xs: 'auto' },
              maxWidth: '100%',
              alignSelf: 'center',
              cursor: 'pointer',
              '&:hover': {
                boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                transition: '0.3s',
              },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',
                alignSelf: 'center',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',

                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/alabama-flag.svg"
                loading="lazy"
                alt="alabama"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',

                // sm: '15px !important',
              }}
            >
              Alabama
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/alaska-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: 'grid',
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              // width: { md: 'auto', sm: '250px !important', xs: 'auto' },
              maxWidth: '100%',
              alignSelf: 'center',
              cursor: 'pointer',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',
                alignSelf: 'center',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',

                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/alaska-flag.svg"
                loading="lazy"
                alt="alabama"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',

                // sm: '15px !important',
              }}
            >
              Alaska
            </Typography>
          </Paper>
        </Link>
      </Grid>

      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/arizona-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: 'grid',
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              width: { md: 'auto', sm: '250px', xs: 'auto' },
              maxWidth: '100%',
              alignSelf: 'center',
              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',
                alignSelf: 'center',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/arizona-flag.svg"
                loading="lazy"
                alt="arizona-flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Arizona
            </Typography>
          </Paper>
        </Link>
      </Grid>

      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/arkansas-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: 'grid',
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/arkansas-flag.svg"
                loading="lazy"
                alt="Arkansas flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Arkansas
            </Typography>
          </Paper>
        </Link>
      </Grid>

      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/california-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: 'grid',
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/california-flag.svg"
                loading="lazy"
                alt="california flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              California
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/colorado-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/colorado-flag.svg"
                loading="lazy"
                alt="colorado flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Colorado
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/connecticut-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/connecticut-flag.svg"
                loading="lazy"
                alt="connecticut flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Connecticut
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/delaware-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/delaware-flag.svg"
                loading="lazy"
                alt="delaware flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Delaware
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/district-of-columbia-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/dist-columbia-flag.svg"
                loading="lazy"
                alt="Dist. of Columbia flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Dist. of Columbia
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/florida-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/florida-flag.svg"
                loading="lazy"
                alt="Dist. of Columbia flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Florida
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/georgia-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/georgia-flag.svg"
                loading="lazy"
                alt="georgia flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Georgia
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/hawaii-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/hawaii-flag.svg"
                loading="lazy"
                alt="Hawaii flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Hawaii
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/idaho-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/flag-idaho.svg"
                loading="lazy"
                alt="Idaho flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Idaho
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/illinois-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/illinois-flag.svg"
                loading="lazy"
                alt="illinois flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Illinois
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/indiana-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/indiana-flag.svg"
                loading="lazy"
                alt="indiana flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Indiana
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/iowa-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/iowa-flag.svg"
                loading="lazy"
                alt="iowa flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Iowa
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/kansas-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/kansas-flag.svg"
                loading="lazy"
                alt="kansas flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Kansas
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/kentucky-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/kentucky-flag.svg"
                loading="lazy"
                alt="Kentucky flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Kentucky
            </Typography>
          </Paper>
        </Link>
      </Grid>

      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/louisiana-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/louisiana-flag.svg"
                loading="lazy"
                alt="Louisiana flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Louisiana
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/maine-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/maine-flag.svg"
                loading="lazy"
                alt="Maine flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Maine
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/maryland-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/maryland-flag.svg"
                loading="lazy"
                alt="Maryland flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Maryland
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/massachusetts-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/massachusetts-flag.svg"
                loading="lazy"
                alt="Massachusetts flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Massachusetts
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/michigan-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/michigan-flag.svg"
                loading="lazy"
                alt="Michigan flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Michigan
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/minnesota-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/minnesota-flag.svg"
                loading="lazy"
                alt="minnesota flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Minnesota
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/mississippi-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/mississippi-flag.svg"
                loading="lazy"
                alt="mississippi flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Mississippi
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/missouri-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/missouri-flag.svg"
                loading="lazy"
                alt="Missouri flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Missouri
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/montana-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/montana-flag.svg"
                loading="lazy"
                alt="Montana flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Montana
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/nebraska-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/nebraska-flag.svg"
                loading="lazy"
                alt="Nebraska flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Nebraska
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/nevada-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/nevada-flag.svg"
                loading="lazy"
                alt="Nebraska flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Nevada
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/new-hampshire-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/new-hampshire-flag.svg"
                loading="lazy"
                alt="Nebraska flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              New Hampshire
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/new-jersey-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/new-jersey-flag.svg"
                loading="lazy"
                alt="New Jersey flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              New Jersey
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/new-mexico-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                loading="lazy"
                alt="New Mexico flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              New Mexico
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/new-york-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/new-york-flag.svg"
                loading="lazy"
                alt="New Mexico flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              New York
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/north-carolina-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/north-carolina-flag.svg"
                loading="lazy"
                alt="North Carolina flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              North Carolina
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/north-dakota-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/north-dakota-flag.svg"
                loading="lazy"
                alt="North Dakota flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              North Dakota
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/ohio-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/ohio-flag.svg"
                loading="lazy"
                alt="Ohio flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Ohio
            </Typography>
          </Paper>
        </Link>
      </Grid>

      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/oklahoma-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/oklahoma-flag.svg"
                loading="lazy"
                alt="Oklahoma flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Oklahoma
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/oregon-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/oregon-flag.svg"
                loading="lazy"
                alt="Oregon flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Oregon
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/pennsylvania-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/pennsylvania-flag.svg"
                loading="lazy"
                alt="Pennsylvania flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Pennsylvania
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/rhode-island-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/rhode-island-flag.svg"
                loading="lazy"
                alt="Rhode Island flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Rhode Island
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/south-carolina-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/south-carolina-flag.svg"
                loading="lazy"
                alt="South Carolina flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              South Carolina
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/south-dakota-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/south-dakota-flag.svg"
                loading="lazy"
                alt="South Carolina flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              South Dakota
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/tennessee-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/tennessee-flag.svg"
                loading="lazy"
                alt="South Carolina flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Tennessee
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/texas-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/texas-flag.svg"
                loading="lazy"
                alt="South Carolina flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Texas
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/utah-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/utah-flag.svg"
                loading="lazy"
                alt="utah"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Utah
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/vermont-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/vermont-flag.svg"
                loading="lazy"
                alt="Vermont flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Vermont
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/virginia-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/virginia-flag.svg"
                loading="lazy"
                alt="Virginia flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Virginia
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/west-virginia-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/west-virginia-flag.svg"
                loading="lazy"
                alt="West Virginia flag"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              West Virginia
            </Typography>
          </Paper>
        </Link>
      </Grid>

      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/wisconsin-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              boxAlign: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/wisconsin-flag.svg"
                loading="lazy"
                alt="Wisconsin"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Wisconsin
            </Typography>
          </Paper>
        </Link>
      </Grid>
      <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
        <Link
          href="/form-1099-state-filing/wyoming-filing-requirements/"
          sx={{ textDecoration: 'none' }}
        >
          <Paper
            variant="outlined"
            sx={{
              p: { xs: 3, sm: 2, md: 3 },
              borderRadius: 3,
              display: { md: 'grid', sm: 'flex', xs: 'grid' },
              gridTemplateColumns: 'auto auto ',
              columnGap: 1,
              placeContent: 'start',
              backgroundColor: '#fdfdfd',
              transition: 'all 0.3s ease-in-out',
              textDecoration: 'none',
              // cursor: 'pointer',
              alignItems: 'center',
              boxAlign: 'center',
              maxWidth: '100%',
              minHeight: '100%',

              // '&:hover': {
              //   boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
              //   transition: '0.3s',
              // },
            }}
          >
            <Box
              sx={{
                width: '24px !important',
                height: '17px !important',
                position: 'relative',

                '& .state-flag': {
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                  inset: '0px',
                  color: 'transparent',
                },
              }}
            >
              <img
                srcSet="/assets/images/state-flag/wyoming-flag.svg"
                loading="lazy"
                alt="Wisconsin"
                width="100%"
                height="100%"
                className="state-flag"
              />
            </Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: '15px !important',
              }}
            >
              Wyoming
            </Typography>
          </Paper>
        </Link>
      </Grid>
    </Grid>
  );
}
